import React from 'react';

import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { IconButton, Stack, Tab, Tabs, Tooltip, useTheme } from '@mui/material';

import AskRichardWordmark from '~/components/brand/AskRichardWordmark';

export type PaneTab = 'ask' | 'block' | 'lens';

type PaneTabsProps = { tab: PaneTab; withAsk: boolean; withBlock: boolean; onTab: (tab: PaneTab) => void; onCollapse: () => void };

export const paneTabId = (tab: PaneTab) => `lens-pane-tab-${tab}`;
export const panePanelId = (tab: PaneTab) => `lens-pane-${tab}`;

export default function PaneTabs({ tab, withAsk, withBlock, onTab, onCollapse }: PaneTabsProps) {
  const dark = useTheme().palette.mode === 'dark';
  const tabs: Array<[PaneTab, string]> = [
    ...(withAsk ? [['ask', 'askRichard'] as [PaneTab, string]] : []),
    ...(withBlock ? [['block', 'Block'] as [PaneTab, string]] : []),
    ['lens', 'Lens'],
  ];
  return (
    <Stack alignItems="center" direction="row" sx={{ borderBottom: 1, borderColor: 'divider', flexShrink: 0 }}>
      <Tooltip title="Hide the panel">
        <IconButton aria-label="Hide the panel" onClick={onCollapse} size="small" sx={{ mx: 0.5 }}>
          <ChevronRightIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tabs aria-label="Lens panel" onChange={(_, next: PaneTab) => onTab(next)} sx={{ flex: 1, minHeight: 40 }} value={tab} variant="fullWidth">
        {tabs.map(([value, label]) => (
          <Tab
            aria-controls={panePanelId(value)}
            aria-label={label}
            icon={value === 'ask' ? <AutoAwesomeOutlinedIcon fontSize="small" /> : undefined}
            iconPosition="start"
            id={paneTabId(value)}
            key={value}
            label={value === 'ask' ? <AskRichardWordmark inverted={dark} size={14} /> : label}
            sx={{ gap: 0.5, minHeight: 40, textTransform: 'none', '& .MuiTab-iconWrapper': { m: 0 } }}
            value={value}
          />
        ))}
      </Tabs>
    </Stack>
  );
}
